export const DEFAULT_ETH = {
  name: 'Default (ETH)',
  path: "m/44'/60'/0'/0/<account>"
};
export const LEDGER_ETH = {
  name: 'Ledger (ETH)',
  path: "m/44'/60'/0'/<account>"
};
export const LEDGER_ETC = {
  name: 'Ledger (ETC)',
  path: "m/44'/60'/160720'/0'/<account>"
};
export const DEFAULT_ETC = {
  name: 'Default (ETC)',
  path: "m/44'/61'/0'/0/<account>"
};
export const TESTNET_ETH = {
  name: 'Testnet (ETH)',
  path: "m/44'/1'/0'/0/<account>"
};
export const DEFAULT_EXP = {
  name: 'Default (EXP)',
  path: "m/44'/40'/0'/0/<account>"
};
export const DEFAULT_UBQ = {
  name: 'Default (UBQ)',
  path: "m/44'/108'/0'/0/<account>"
};
export const DEFAULT_TOMO = {
  name: 'Default (TOMO)',
  path: "m/44'/889'/0'/0/<account>"
};
export const DEFAULT_ELLA = {
  name: 'Default (ELLA)',
  path: "m/44'/163'/0'/0/<account>"
};
export const DEFAULT_MUSIC = {
  name: 'Default (MUSIC)',
  path: "m/44'/184'/0'/0/<account>"
};
export const DEFAULT_EGEM = {
  name: 'Default (EGEM)',
  path: "m/44'/1987'/0'/0/<account>"
};
export const DEFAULT_CLO = {
  name: 'Default (CLO)',
  path: "m/44'/820'/0'/0/<account>"
};
export const TESTNET_RSK = {
  name: 'Testnet (RSK)',
  path: "m/44'/37310'/0'/0/<account>"
};
export const MAINNET_RSK = {
  name: 'Mainnet (RSK)',
  path: "m/44'/137'/0'/0/<account>"
};
export const DEFAULT_GO = {
  name: 'Default (GO)',
  path: "m/44'/6060'/0'/0/<account>"
};
export const DEFAULT_AKA = {
  name: 'Default (AKA)',
  path: "m/44'/200625'/0'/0/<account>"
};
export const DEFAULT_PIRL = {
  name: 'Default (PIRL)',
  path: "m/44'/164'/0'/0/<account>"
};
export const DEFAULT_ATH = {
  name: 'Default (ATH)',
  path: "m/44'/1620'/0'/0/<account>"
};
export const DEFAULT_ETHO = {
  name: 'Default (ETHO)',
  path: "m/44'/1313114'/0'/0/<account>"
};
export const DEFAULT_MIX = {
  name: 'Default (MIX)',
  path: "m/44'/76'/0'/0/<account>"
};
export const DEFAULT_THUNDERCORE = {
  name: 'Default (THUNDERCORE)',
  path: "m/44'/1001'/0'/0/<account>"
};
export const DEFAULT_WEB = {
  name: 'Default (WEB)',
  path: "m/44'/227'/0'/0/<account>"
};
export const DEFAULT_METADIUM = {
  name: 'Default (METADIUM)',
  path: "m/44'/916'/0'/0/<account>"
};
export const DEFAULT_ASK = {
  name: 'Default (ASK)',
  path: "m/44'/2221'/0'/0/<account>"
};
export const DEFAULT_AUX = {
  name: 'Default (AUX)',
  path: "m/44'/344'/0'/0/<account>"
};
export const DEFAULT_EWC = {
  name: 'Default (EWC)',
  path: "m/44'/246'/0'/0/<account>"
};
export const DEFAULT_VOLTA = {
  name: 'Default (VOLTA)',
  path: "m/44'/73799'/0'/0/<account>"
};
export const DEFAULT_AVAXC = {
  name: 'Default (AVAXC)',
  path: "m/44'/9005'/0'/0/<account>"
};
export const DEFAULT_EVRICE = {
  name: 'Default (EVC)',
  path: "m/44'/1020'/0'/0/<account>"
};
export const DEFAULT_POA = {
  name: 'Default (POA)',
  path: "m/44'/178'/0'/0/<account>"
};
export const DEFAULT_ARTIS_SIGMA1 = {
  name: 'Sigma1 (ATS)',
  path: "m/44'/246529'/0'/0/<account>"
};
export const DEFAULT_ARTIS_TAU1 = {
  name: 'Tau1 (ATS)',
  path: "m/44'/246785'/0'/0/<account>"
};
export const DEFAULT_ETI = {
  name: 'Default (ETI)',
  path: "m/44'/464'/0'/0/<account>"
};
export const DEFAULT_POLYGON = {
  name: 'Default (Polygon)',
  path: "m/44'/966'/0'/0/<account>"
};
export const DEFAULT_BSC = {
  name: 'Default (BSC)',
  path: "m/44'/9006'/0'/0/<account>"
};
export const DEFAULT_XDAI = {
  name: 'Default (XDAI)',
  path: "m/44'/700'/0'/0/<account>"
};
export const DEFAULT_HECO = {
  name: 'Default (HECO)',
  path: "m/44'/1010'/0'/0/<account>"
};
export const DEFAULT_FTM = {
  name: 'Default (FTM)',
  path: "m/44'/1007'/0'/0/<account>"
};
export const DEFAULT_XDC = {
  name: 'Default (XDC)',
  path: "m/44'/550'/0'/0/<account>"
};
export const LEDGER_LIVE_ETH = {
  name: 'Ledger Live (ETH)',
  path: "m/44'/60'/<account>'/0/0",
  isHardened: true
};
export const LEDGER_LIVE_ETC = {
  name: 'Ledger Live (ETC)',
  path: "m/44'/61'/<account>'/0/0",
  isHardened: true
};
export const EXTENDED_KEY_CHILDREN = {
  name: 'Extended Key Children',
  path: 'm/<account>',
  isHardened: true
};
export const ALL_DERIVATION_PATHS = [DEFAULT_ETH, LEDGER_ETH, LEDGER_ETC, DEFAULT_ETC, TESTNET_ETH, DEFAULT_EXP, DEFAULT_UBQ, DEFAULT_TOMO, DEFAULT_ELLA, DEFAULT_MUSIC, DEFAULT_EGEM, DEFAULT_CLO, TESTNET_RSK, MAINNET_RSK, DEFAULT_GO, DEFAULT_AKA, DEFAULT_PIRL, DEFAULT_ATH, DEFAULT_ETHO, DEFAULT_MIX, DEFAULT_THUNDERCORE, DEFAULT_WEB, DEFAULT_METADIUM, DEFAULT_ASK, DEFAULT_AUX, DEFAULT_EWC, DEFAULT_VOLTA, LEDGER_LIVE_ETH, LEDGER_LIVE_ETC, DEFAULT_AVAXC, DEFAULT_EVRICE, DEFAULT_ARTIS_SIGMA1, DEFAULT_POA, DEFAULT_ARTIS_TAU1, DEFAULT_ETI, DEFAULT_POLYGON, DEFAULT_BSC, DEFAULT_XDAI, DEFAULT_HECO, DEFAULT_FTM, DEFAULT_XDC];
export const LEDGER_DERIVATION_PATHS = [DEFAULT_ETH, LEDGER_ETH, LEDGER_ETC, TESTNET_ETH, LEDGER_LIVE_ETH];
export const TREZOR_DERIVATION_PATHS = [...ALL_DERIVATION_PATHS.filter(path => !path.isHardened)];
export const GRIDPLUS_DERIVATION_PATHS = [DEFAULT_ETH];
//# sourceMappingURL=dpaths.js.map